import React, { useState } from 'react';

import QRCode  from 'react-qr-code';

const QrCodeComponent=(props)=>{
    return (
          <QRCode value={props.nodeid} />
    )
   
}

export default QrCodeComponent